import React from "react";
import { Table, Tag, Button, Input, message, Icon, Row, Col, Spin } from "antd"
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import { Auth, API } from "aws-amplify"
import moment from 'moment'
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
class InvoiceTable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            facturas: [],
            lastInvoice:null,
            loading: true
        }
    }

    componentDidMount() {
        if(this.props.invoices) {
            this.setState({ loading: false, facturas: this.props.invoices, lastInvoice: null})
        }
        else if (this.props.batchId === null || this.props.batchId=== undefined){
            Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/invoices',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                    }
                )
                    .then(response => {
                        let facturasFilterNoBatch = response['invoices'].filter(inv => (inv.batchId !== null && inv.estado !== 'REJECTED' ))
                        let facturasFilterBatch = response['invoices'].filter(invo => invo.batchId === null)
                        this.setState({ loading: false, facturas: facturasFilterNoBatch.concat(facturasFilterBatch), lastInvoice: response['last'] })
                    })
                    .catch(err => {
                        this.setState({loading:false})})
            })
        }else{

            Auth.currentSession()
                .then(response => {
                    API.get(
                        'test',
                        '/root/batch/' + this.props.batchId +'/invoices',
                        {
                            headers: {
                                Authorization: response.getIdToken().getJwtToken()
                            }
                        }
                    )
                        .then(response => {
                            this.setState({ loading: false, facturas: response['invoices']})
                        })
                        .catch(err => {
                            console.log(err)
                            message.error('No se pudo leer el Lote')})
                })
        }

    }


    getPdf(invoiceId, userId){

    this.setState({loading:true})
    Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/pdf/'+invoiceId,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    },
                    queryStringParameters:{
                        userId:userId
                    }

                }
            )
                .then(response => {
                    this.setState({ loading: false})
                    var byteCharacters = atob(response['pdf']);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL)
                })

                .catch(err => {
                    message.error('Error generando PDF')
                    this.setState({loading:false})
                    console.log(err)})
        })
    }


    render() {
        if (this.state.loading){
            return(
<>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }else{

        let columns = [
            {
                title: "Fecha",
                dataIndex: "fecha",
                key: "fecha",
                render: (value, row, index) => {
                    return {
                        children: value ? moment(value).format("YYYY-MM-DD HH:MM") : ''
                    }
                },
                sorter: (a, b) => moment(a.fecha).diff(b.fecha),
                defaultSortOrder: 'descend'
            },
            {
                title: "N° Comprobante",
                dataIndex: "nroDeComprobante",
                key: "nroDeComprobante",
                sorter: (a, b) => a.nroDeComprobante - b.nroDeComprobante,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <Input
                            ref={node => {
                                this.searchInput = node;
                            }}
                            placeholder="Buscar comprobante"
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => confirm()}
                            style={{ width: 188, marginBottom: 8, display: 'block' }}
                        />
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon="search"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                        >
                            Buscar
                        </Button>
                        <Button
                            onClick={() => clearFilters()}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                    </div>
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                onFilter: (value, record) => record.nroDeComprobante.toString().toLowerCase().includes(value.toLowerCase()),
                onFilterDropdownVisibleChange: visible => {
                    if (visible) {
                        setTimeout(() => this.searchInput.select())
                    }
                }
            },
            {
                title: "Tipo",
                dataIndex: "tipoDeComprobante",
                key: "tipoDeComprobante",
                render: (value) => {
                    let text = ""
                    switch (value) {
                        case 11:
                            text = "Factura C"
                            break
                        case 13:
                            text = "Nota de Crédito C"
                            break
                        case 12:
                            text = "Nota de Débito C"
                            break
                        case 15:
                            text = "Recibos C"
                            break
                        default:
                            break
                    }
                    return {
                        children:
                            <Tag>
                                {text}
                            </Tag>
                    }
                },
                filters: [
                    {
                        value: 11,
                        text: "Factura C"
                    },
                    {
                        value: 13,
                        text: "Nota de Crédito C"
                    },
                    {
                        value: 12,
                        text: "Nota de Débito C"
                    },
                    {
                        value: 15,
                        text: "Recibos C"
                    }
                ],
                filterMultiple: true,
                onFilter: (value, record) => record.tipoDeComprobante.toString().indexOf(value) === 0,
            },
            {
                title: "DNI/CUIT Cliente",
                dataIndex: "nroDocumento",
                key: "nroDocumento",
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <Input
                            ref={node => {
                                this.searchInput = node;
                            }}
                            placeholder="Buscar DNI/CUIT Cliente"
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => confirm()}
                            style={{ width: 188, marginBottom: 8, display: 'block' }}
                        />
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon="search"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                        >
                            Buscar
                        </Button>
                        <Button
                            onClick={() => clearFilters()}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                    </div>
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),

                onFilter: (value, record) => (record.nroDocumento != null) ? record.nroDocumento.toString().toLowerCase().includes(value.toLowerCase()) : "",
                onFilterDropdownVisibleChange: visible => {
                    if (visible) {
                        setTimeout(() => this.searchInput.select())
                    }
                }
            },
            {
                title: "Razón Social",
                dataIndex: (this.props.batchId === null || this.props.batchId=== undefined)?"razonSocialCliente":"razon_social",
                key: (this.props.batchId === null || this.props.batchId=== undefined)?"razonSocialCliente":"razon_social"
            },
            {
                title: "Importe",
                dataIndex: "importeTotal",
                key: "importeTotal",
                sorter: (a, b) => a.importeTotal - b.importeTotal
            },

            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                render: (value) => {
                    let text = ""
                    switch (value) {
                        case "DRAFT":
                            text = "Borrador"
                            break
                        case "PENDING_AFIP":
                            text = "Pendiente"
                            break
                        case "EMITTED":
                            text = "Emitida"
                            break
                        case "CANCELED":
                            text = "Cancelada"
                            break
                        case "QUEUED":
                            text = "Cola"
                            break
                        case "REJECTED":
                            text = "Rechazada"
                            break
                        case "PRESENTED":
                            text = "Presentada"
                        default:
                            break;

                    }
                    return {
                        children:
                            <Tag>
                                {text}
                            </Tag>
                    }
                }
            }

        ]

        if (!this.props.dashboard && (!this.props.batchId || this.props.batchId === null) && this.props.invoices == null) {
            columns.push({
                title: "Acciones",
                dataIndex: "actions",
                key: "actions",
                render: (text, record, index) => {
                    return {
                        children: <Button onClick={() => this.props.history.push("/visualizar-factura/"+record.invoiceId)}>
                        Ver
                    </Button>
                    }
                }
            })
        } else if (!this.props.dashboard && (this.props.batchId || this.props.invoices)) {
            columns.push({
                title: "Acciones",
                dataIndex: "actions",
                key: "actions",
                render: (text, record, index) => {
                    return {
                        children: <Button disabled={record.estado === 'PRESENTED'} onClick={() => this.getPdf(record.invoiceId, record.userId)}>
                        Ver pdf
                    </Button>
                    }
                }
            })
        }

        let facturas = this.state.facturas.map(value => {
            value["key"] = value["invoiceId"]
            return value
        })

    return (
        <Table
            columns={columns}
            dataSource={this.props.dashboard === true ? facturas.length >3?facturas.slice(facturas.length-3,facturas.length):facturas:facturas}
            pagination={{
                showSizeChanger: !this.props.dashboard,
                pageSizeOptions: ['10', '20', '30', '100'],
                defaultPageSize: 10
            }}
            loading={this.state.loadings}
            scroll={{ x: "max-content" }}
        />

    );

}}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceTable));
